import React from 'react';

const cs6AssistantConversation = (
  <div className="space-y-4">
    {/* Assistant Agent Introduction */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          The following scenarios depict interactions between users and proactive smart home assistants. Please share your initial impressions regarding their usefulness, appropriateness, and invasiveness.
        </div>
      </div>
    </div>

    {/* Subject Response - Initial Impressions */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Scenarios like the Alarm Reminder and Emergency are very beneficial and appropriately timed. However, scenarios such as the Quiz Spoiler feel intrusive and poorly timed. The Health Risk alert could be helpful if presented sensitively and contextually.
        </div>
      </div>
    </div>

    {/* Assistant Agent - Preferences Analysis */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Could you elaborate on the factors influencing your perceptions of appropriateness and invasiveness in these proactive scenarios?
        </div>
      </div>
    </div>

    {/* Subject Detailed Analysis */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Urgency and immediate benefit strongly influence my perception of appropriateness. I prefer interventions that respect autonomy and provide supportive guidance rather than directives. Invasive interventions are those that interrupt ongoing leisure or personal activities without clear necessity.
        </div>
      </div>
    </div>

    {/* Assistant Agent - Customization Preferences */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          What are your preferences regarding customization and control over proactive assistant interactions?
        </div>
      </div>
    </div>

    {/* Subject Response - Customization Preferences */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          I strongly prefer interactions that allow me to maintain control. The assistant should suggest options rather than imposing decisions. For critical alerts, immediate interaction is acceptable, but for less urgent issues, the assistant should offer assistance only upon my request.
        </div>
      </div>
    </div>

    {/* Assistant Agent - Final Reflections */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Could you summarize your overall reflections on proactive voice assistants and any potential improvements?
        </div>
      </div>
    </div>

    {/* Subject Final Reflections */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Proactive voice assistants have significant potential to improve daily productivity and well-being. However, they must prioritize context-awareness, timing precision, and user autonomy. Customizable settings that clearly define boundaries and respect user control are essential to minimize frustration and enhance user satisfaction.
        </div>
      </div>
    </div>
  </div>
);

export default cs6AssistantConversation;
